(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daloda-find-your-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const matrix = {
      'toddler|bassinet': 'TBUV002',
      'toddler|toddler': 'BBUV00A',
      'toddler|rumble_v3': 'BBUV00A',
      'toddler|rumble_v2': 'TRUV001',
      'toddler|mesa': 'TMUV001',
      'rumble_v3|bassinet': 'TBUV001',
      'rumble_v3|toddler': 'BBUV00B',
      'rumble_v3|rumble_v3': 'BBUV00B',
      'rumble_v3|rumble_v2': 'TRUV001',
      'rumble_v3|mesa': 'BBUV00B',
      'rumble_v2|bassinet': 'TBUV001',
      'rumble_v2|toddler': 'BBUV00B',
      'rumble_v2|rumble_v3': 'BBUV00B',
      'rumble_v2|rumble_v2': 'TRUV001',
      'rumble_v2|mesa': 'BBUV00B'
    };

    const kitParts = {
      TBUV001: ['MUUV1'],
      TBUV002: ['MUUV1', 'TLUV1'],
      BBUV00A: ['MUUV1', 'TLUV2'],
      BBUV00B: ['MUUV1'],
      BBUV00C: ['MUUV1', 'TLUV1', 'TLUV2'],
      TRUV001: ['RUUV1', 'TLUV2'],
      TMUV001: ['MUUV1', 'TLUV2']
    };

    const partOrder = ['MUUV1', 'TLUV1', 'TLUV2', 'RUUV1'];
    const bundleRoutes = {
      MUUV1: { sku: 'BBUV00B' },
      'MUUV1|TLUV1': { sku: 'TBUV002' },
      'MUUV1|TLUV2': { sku: 'BBUV00A' },
      'TLUV2|RUUV1': { sku: 'TRUV001' },
      'MUUV1|TLUV1|TLUV2': { sku: 'BBUV00C' },
      'MUUV1|TLUV2|RUUV1': { sku: 'BBUV00D' },
      'MUUV1|TLUV1|TLUV2|RUUV1': { sku: 'BBUV00E' }
    };

    const labels = {
      stroller: {
        vista_v3: 'Vista V3',
        vista_v2: 'Vista V2',
        vista_2015: 'Vista 2015+'
      },
      carrier: {
        toddler: 'Toddler Seat',
        rumble_v3: 'RumbleSeat V2+ / V3',
        rumble_v2: 'RumbleSeat Original / V2',
        bassinet: 'Bassinet',
        mesa: 'Mesa/Aria Car Seat'
      }
    };

    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);

    const normalizeSku = (sku) => String(sku || '').trim().toUpperCase();

    const initFinder = (root) => {
      if (!root || root.dataset.dkyReady === 'true') return;
      const configNode = root.querySelector('[data-dky-config]');
      if (!configNode) return;

      root.dataset.dkyReady = 'true';
      const config = JSON.parse(configNode.textContent);
      const screens = [...root.querySelectorAll('[data-dky-screen]')];
      const progress = root.querySelector('[data-dky-progress]');
      const stepLabel = root.querySelector('[data-dky-step-label]');
      const summary = root.querySelector('[data-dky-summary]');
      const selectedStroller = root.querySelector('[data-dky-selected-stroller]');
      const savedListMount = root.querySelector('[data-dky-saved-list]');
      const savedCount = root.querySelector('[data-dky-saved-count]');
      const mobileSavedCount = root.querySelector('[data-dky-mobile-saved-count]');
      const composerMessage = root.querySelector('[data-dky-composer-message]');
      const saveButton = root.querySelector('[data-dky-action="save-configuration"]');
      const addAnotherButtons = [...root.querySelectorAll('[data-dky-action="add-another-configuration"]')];
      const findButtons = [...root.querySelectorAll('[data-dky-action="find-kit"]')];
      const productMount = root.querySelector('[data-dky-product-card]');
      const live = root.querySelector('[data-dky-live]');
      const guide = root.querySelector('[data-dky-guide]');
      const savedPanel = root.querySelector('.dky__saved-panel');
      const mobileSavedBar = root.querySelector('[data-dky-mobile-saved-bar]');
      const upperPosition = root.querySelector('.dky__position-card--upper');
      const lowerPosition = root.querySelector('.dky__position-card--lower');
      const composerActions = root.querySelector('.dky__composer-actions');
      const resultHeading = root.querySelector('.dky__result-heading');
      const guidanceTargets = [upperPosition, lowerPosition, composerActions, savedPanel].filter(Boolean);
      let guidanceTimer = null;
      const state = {
        screen: 'stroller',
        stroller: '',
        draftLower: '',
        draftUpper: '',
        configurations: [],
        recommendedSku: ''
      };

      const newAnalyticsId = (prefix) => {
        const random = window.crypto?.randomUUID
          ? window.crypto.randomUUID().replaceAll('-', '')
          : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
        return `${prefix}_${random}`;
      };

      const storedAnalyticsId = (storageName, key, prefix) => {
        try {
          const storage = window[storageName];
          const current = storage.getItem(key);
          if (current) return current;
          const created = newAnalyticsId(prefix);
          storage.setItem(key, created);
          return created;
        } catch (_) {
          return '';
        }
      };

      const sessionId = storedAnalyticsId('sessionStorage', 'daloda-kit-finder-session', 'dkys') || newAnalyticsId('dkys');
      const visitorId = storedAnalyticsId('localStorage', 'daloda-kit-finder-visitor', 'dkyv') || sessionId;
      const pendingFunnelEvents = new Set();

      const findSku = (sku) => {
        const target = normalizeSku(sku);
        for (const product of config.products) {
          const variant = product.variants.find((candidate) => normalizeSku(candidate.sku) === target);
          if (variant) return { product, variant };
        }
        return null;
      };

      const findSourceProduct = (source) => {
        const productId = config.sources?.[source];
        if (!productId) return null;
        const product = config.products.find((candidate) => String(candidate.id) === String(productId));
        if (!product) return null;
        const variant = product.variants.find((candidate) => candidate.available) || product.variants[0];
        return variant ? { product, variant } : null;
      };

      const screenStep = (name) => ({ stroller: 1, unsupported: 1, builder: 2, result: 3 })[name] || 1;

      const scrollToMobileStep = (target, block = 'start', includeDesktop = false) => {
        if (!target || (!includeDesktop && !window.matchMedia('(max-width: 600px)').matches)) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block
        }));
      };

      const clearNextStep = () => {
        if (guidanceTimer) window.clearTimeout(guidanceTimer);
        guidanceTimer = null;
        guidanceTargets.forEach((target) => {
          target.classList.remove('is-next-step', 'is-next-step--pulse');
          target.removeAttribute('aria-current');
        });
      };

      const highlightNextStep = (target, scrollBlock = 'start', shouldScroll = true, includeDesktop = false) => {
        if (!target) return;
        clearNextStep();
        target.classList.add('is-next-step');
        target.setAttribute('aria-current', 'step');
        void target.offsetWidth;
        target.classList.add('is-next-step--pulse');
        guidanceTimer = window.setTimeout(() => {
          target.classList.remove('is-next-step--pulse');
          guidanceTimer = null;
        }, 1300);
        if (shouldScroll) scrollToMobileStep(target, scrollBlock, includeDesktop);
      };

      const showScreen = (name) => {
        const scrollTop = window.scrollY;
        const scrollLeft = window.scrollX;
        if (root.contains(document.activeElement) && document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }

        state.screen = name;
        screens.forEach((screen) => { screen.hidden = screen.dataset.dkyScreen !== name; });
        mobileSavedBar.hidden = name !== 'builder';
        const step = screenStep(name);
        progress.style.width = `${(step / 3) * 100}%`;
        stepLabel.textContent = name === 'result' ? 'Complete' : `Step ${step} of 3`;

        window.scrollTo(scrollLeft, scrollTop);
        window.requestAnimationFrame(() => window.scrollTo(scrollLeft, scrollTop));
      };

      const productForm = (product, variant, role) => {
        const formId = `DkyProductForm-${config.sectionId}-${variant.id}-${role}`;
        const addText = variant.available ? 'Add kit to cart' : 'Sold out';
        const media = variant.image || product.images[0]?.src || '';
        const desiredConfigurations = state.configurations.map((item) => (
          `LOWER: ${labels.carrier[item.lower]} / UPPER: ${labels.carrier[item.upper]}`
        )).join(' | ');
        const includedParts = calculateParts().join(', ');

        return `
          <product-form-component
            data-section-id="${escapeHtml(config.sectionId)}"
            data-product-id="${escapeHtml(product.id)}"
            data-product-url="${escapeHtml(product.url)}"
            data-quantity-default="1"
            on:submit="/handleSubmit"
          >
            <div class="dky__visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
            <form method="post" action="${escapeHtml(config.cartAddUrl)}" id="${escapeHtml(formId)}" class="dky__form" enctype="multipart/form-data" data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" ref="variantId" value="${escapeHtml(variant.id)}">
              <input type="hidden" name="properties[Stroller]" value="${escapeHtml(labels.stroller[state.stroller])}">
              <input type="hidden" name="properties[Desired configurations]" value="${escapeHtml(desiredConfigurations)}">
              <input type="hidden" name="properties[Included part SKUs]" value="${escapeHtml(includedParts)}">
              <div ref="productFormButtons">
                <add-to-cart-component
                  ref="addToCartButtonContainer"
                  data-product-variant-media="${escapeHtml(media)}"
                  data-add-to-cart-animation="false"
                >
                  <button
                    type="submit"
                    name="add"
                    ref="addToCartButton"
                    on:click="/handleClick"
                    class="dky__primary"
                    data-dky-product-action="add_to_cart"
                    ${variant.available ? '' : 'disabled'}
                  >
                    <span class="dky__add-label--default">${escapeHtml(addText)}</span>
                    <span class="dky__add-label--added">Added ✓</span>
                  </button>
                </add-to-cart-component>
              </div>
            </form>
          </product-form-component>
        `;
      };

      const missingProduct = (reference, parts = []) => `
        <div class="dky__missing">
          <h3>We need to double-check this match</h3>
          <p>${config.designMode
            ? `No Shopify bundle is assigned for ${escapeHtml(reference)}${parts.length ? ` (${parts.map(escapeHtml).join(' + ')})` : ''}. Select it in this section’s Product sources settings.`
            : 'This recommendation is temporarily unavailable online. Please contact Daloda and we’ll confirm the correct kit.'}</p>
          <a class="dky__product-link" href="${escapeHtml(config.contactUrl)}">Contact Daloda</a>
        </div>
      `;

      const renderGallery = (product) => {
        const images = product.images || [];
        if (!images.length) {
          return '<div class="dky__gallery-placeholder">Product image coming soon</div>';
        }

        const first = images[0];
        return `
          <div class="dky__gallery" data-dky-gallery data-images="${escapeHtml(JSON.stringify(images))}">
            <img
              class="dky__gallery-image"
              data-dky-gallery-image
              src="${escapeHtml(first.src)}"
              alt="${escapeHtml(first.alt)}"
              width="${escapeHtml(first.width)}"
              height="${escapeHtml(first.height)}"
            >
            ${images.length > 1 ? `
              <button class="dky__gallery-button dky__gallery-button--prev" type="button" data-dky-gallery-prev aria-label="Previous product image">←</button>
              <button class="dky__gallery-button dky__gallery-button--next" type="button" data-dky-gallery-next aria-label="Next product image">→</button>
              <span class="dky__gallery-count" data-dky-gallery-count>1 / ${images.length}</span>
            ` : ''}
          </div>
        `;
      };

      const configurationPillsMarkup = (items) => `
        <ul class="dky__compatibility-list">
          ${items.map((item) => `
            <li class="dky__configuration-pill" data-dky-configuration="${escapeHtml(`${item.lower}|${item.upper}`)}">
              <span><strong>UPPER:</strong> ${escapeHtml(labels.carrier[item.upper])}</span>
              <span><strong>LOWER:</strong> ${escapeHtml(labels.carrier[item.lower])}</span>
            </li>
          `).join('')}
        </ul>
      `;

      const compatibleConfigurations = (parts) => {
        const availableParts = new Set(parts);
        return Object.keys(matrix)
          .filter((pairing) => (kitParts[matrix[pairing]] || []).every((part) => availableParts.has(part)))
          .map((pairing) => {
            const [lower, upper] = pairing.split('|');
            return { lower, upper };
          });
      };

      const groupedCompatibilityMarkup = (items) => {
        const groups = [];
        items.forEach((item) => {
          let group = groups.find((candidate) => candidate.lower === item.lower);
          if (!group) {
            group = { lower: item.lower, uppers: [] };
            groups.push(group);
          }
          group.uppers.push(item.upper);
        });

        return `
          <div class="dky__compatibility-groups">
            ${groups.map((group) => `
              <div class="dky__compatibility-row">
                <span>
                  <strong>UPPER:</strong>
                  <span class="dky__compatible-upper-list">
                    ${group.uppers.map((upper) => `<span class="dky__configuration-value" data-dky-configuration="${escapeHtml(`${group.lower}|${upper}`)}">${escapeHtml(labels.carrier[upper])}</span>`).join('')}
                  </span>
                </span>
                <span><strong>LOWER:</strong> ${escapeHtml(labels.carrier[group.lower])}</span>
              </div>
            `).join('')}
          </div>
        `;
      };

      const resultCompatibilityMarkup = (parts) => {
        const savedKeys = new Set(state.configurations.map((item) => `${item.lower}|${item.upper}`));
        const additional = compatibleConfigurations(parts)
          .filter((item) => !savedKeys.has(`${item.lower}|${item.upper}`));
        const count = state.configurations.length;

        return `
          <div class="dky__compatibility">
            <section class="dky__compatibility-group dky__compatibility-group--saved">
              <strong class="dky__compatibility-title">You saved ${count} ${count === 1 ? 'configuration' : 'configurations'}:</strong>
              ${configurationPillsMarkup(state.configurations)}
            </section>
            ${additional.length ? `
              <section class="dky__compatibility-group dky__compatibility-group--additional">
                <details class="dky__compatibility-details">
                  <summary>
                    <span>View ${additional.length} other compatible ${additional.length === 1 ? 'configuration' : 'configurations'}</span>
                    <span class="dky__compatibility-toggle" aria-hidden="true">+</span>
                  </summary>
                  ${groupedCompatibilityMarkup(additional)}
                </details>
              </section>
            ` : `
              <section class="dky__compatibility-group dky__compatibility-group--additional">
                <p class="dky__compatibility-empty">Your saved list contains every configuration supported by this bundle.</p>
              </section>
            `}
          </div>
        `;
      };

      const renderPrimary = (recommendation) => {
        const { match, parts, reference } = recommendation;
        if (!match) {
          productMount.innerHTML = missingProduct(reference, parts);
          return;
        }

        const { product, variant } = match;
        const hasVariantTitle = variant.title && variant.title !== 'Default Title';
        const configurationCount = state.configurations.length;
        productMount.innerHTML = `
          <article class="dky__product-card">
            ${renderGallery(product)}
            <div class="dky__product-info">
              <h3 class="dky__product-title">${escapeHtml(product.title)}</h3>
              ${hasVariantTitle ? `<p class="dky__variant-title"><strong>Variant:</strong> ${escapeHtml(variant.title)}</p>` : ''}
              <p class="dky__product-note">Calculated from ${configurationCount} saved ${configurationCount === 1 ? 'configuration' : 'configurations'}. Shared adapter parts are included only once.</p>
              <div class="dky__parts">
                <strong>Included adapter parts</strong>
                <ul class="dky__part-list">
                  ${parts.map((part) => `<li>${escapeHtml(part)}</li>`).join('')}
                </ul>
              </div>
              ${resultCompatibilityMarkup(parts)}
              <div class="dky__price-row">
                <span class="dky__price">${escapeHtml(variant.price)}</span>
                ${variant.compareAtPrice ? `<span class="dky__compare-price">${escapeHtml(variant.compareAtPrice)}</span>` : ''}
              </div>
              <p class="dky__availability">${variant.available ? 'Available to add to cart' : 'Currently sold out'}</p>
              ${productForm(product, variant, 'primary')}
              <a class="dky__secondary dky__details-button" href="${escapeHtml(variant.url)}" target="_blank" rel="noopener noreferrer" data-dky-product-action="product_details">View full product details</a>
              <span class="dky__sku">SKU ${escapeHtml(variant.sku)}</span>
            </div>
          </article>
        `;

        const gallery = productMount.querySelector('[data-dky-gallery]');
        if (gallery) initGallery(gallery);
      };

      const initGallery = (gallery) => {
        const images = JSON.parse(gallery.dataset.images || '[]');
        if (images.length < 2) return;
        const image = gallery.querySelector('[data-dky-gallery-image]');
        const count = gallery.querySelector('[data-dky-gallery-count]');
        let index = 0;

        const update = () => {
          const current = images[index];
          image.src = current.src;
          image.alt = current.alt || '';
          image.width = current.width;
          image.height = current.height;
          count.textContent = `${index + 1} / ${images.length}`;
        };

        gallery.querySelector('[data-dky-gallery-prev]').addEventListener('click', () => {
          index = (index - 1 + images.length) % images.length;
          update();
        });
        gallery.querySelector('[data-dky-gallery-next]').addEventListener('click', () => {
          index = (index + 1) % images.length;
          update();
        });

        let touchStartX = null;
        let touchStartY = null;
        gallery.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });
        gallery.addEventListener('touchend', (event) => {
          if (touchStartX === null || touchStartY === null) return;
          const touch = event.changedTouches[0];
          const distanceX = touch.clientX - touchStartX;
          const distanceY = touch.clientY - touchStartY;

          if (Math.abs(distanceX) > 48 && Math.abs(distanceX) > Math.abs(distanceY)) {
            index = distanceX < 0
              ? (index + 1) % images.length
              : (index - 1 + images.length) % images.length;
            update();
          }

          touchStartX = null;
          touchStartY = null;
        }, { passive: true });
      };

      const configurationListMarkup = (items, removable = false) => {
        if (!items.length) {
          return '<p class="dky__saved-empty">No configurations saved yet. Choose an UPPER and LOWER carrier, then add the pairing.</p>';
        }

        return `
          <ol class="dky__saved-list">
            ${items.map((item, index) => `
              <li class="dky__saved-item">
                <span class="dky__saved-number">${index + 1}</span>
                <span class="dky__saved-pair">
                  <span><strong>UPPER:</strong> ${escapeHtml(labels.carrier[item.upper])}</span>
                  <span><strong>LOWER:</strong> ${escapeHtml(labels.carrier[item.lower])}</span>
                </span>
                ${removable ? `<button class="dky__remove-configuration" type="button" data-dky-remove-configuration="${index}" aria-label="Remove configuration ${index + 1}">×</button>` : ''}
              </li>
            `).join('')}
          </ol>
        `;
      };

      const setComposerMessage = (message, isError = false) => {
        composerMessage.textContent = message;
        composerMessage.classList.toggle('is-error', isError);
      };

      const updateDraftControls = () => {
        root.querySelectorAll('[data-dky-lower]').forEach((button) => {
          const selected = button.dataset.dkyLower === state.draftLower;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        root.querySelectorAll('[data-dky-upper]').forEach((button) => {
          const selected = button.dataset.dkyUpper === state.draftUpper;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });

        const ready = Boolean(state.draftLower && state.draftUpper);
        saveButton.disabled = !ready;
        if (ready) setComposerMessage('Pairing ready to save.');
        else if (state.draftLower) setComposerMessage('Now choose an UPPER carrier.');
        else if (state.draftUpper) setComposerMessage('Now choose a LOWER carrier.');
        else setComposerMessage('Start by choosing an UPPER carrier.');
      };

      const removeConfiguration = (index) => {
        state.configurations.splice(index, 1);
        renderSavedConfigurations();
        setComposerMessage('Configuration removed. Choose another pairing or find your kit.');
        live.textContent = 'Configuration removed.';
      };

      const renderSavedConfigurations = () => {
        savedCount.textContent = String(state.configurations.length);
        mobileSavedCount.textContent = String(state.configurations.length);
        savedListMount.innerHTML = configurationListMarkup(state.configurations, true);
        findButtons.forEach((button) => { button.disabled = state.configurations.length === 0; });
        addAnotherButtons.forEach((button) => { button.disabled = state.configurations.length === 0; });
        savedListMount.querySelectorAll('[data-dky-remove-configuration]').forEach((button) => {
          button.addEventListener('click', () => removeConfiguration(Number(button.dataset.dkyRemoveConfiguration)));
        });
      };

      const calculateParts = () => {
        const required = new Set();
        state.configurations.forEach((item) => {
          const sku = matrix[`${item.lower}|${item.upper}`];
          (kitParts[sku] || []).forEach((part) => required.add(part));
        });
        return partOrder.filter((part) => required.has(part));
      };

      const resolveRecommendation = () => {
        const parts = calculateParts();
        if (state.configurations.length === 1) {
          const item = state.configurations[0];
          const sku = matrix[`${item.lower}|${item.upper}`];
          return { match: findSku(sku), parts, reference: `variant SKU ${sku}` };
        }

        const key = parts.join('|');
        const route = bundleRoutes[key];
        if (!route) return { match: null, parts, reference: 'this component combination' };
        if (route.sku) return { match: findSku(route.sku), parts, reference: `variant SKU ${route.sku}` };
        return { match: findSourceProduct(route.source), parts, reference: 'this bundle product' };
      };

      const trackFunnelEvent = (eventType, details = {}) => {
        if (!config.logEndpoint || config.designMode) return;
        const signature = eventType === 'result_viewed'
          ? `${state.stroller}:${state.configurations.map((item) => `${item.lower}|${item.upper}`).sort().join(',')}`
          : eventType;
        const storageKey = `daloda-kit-finder-tracked:${sessionId}:${signature}`;
        try {
          if (window.sessionStorage.getItem(storageKey) || pendingFunnelEvents.has(storageKey)) return;
        } catch (_) {
          // Tracking still works when browser storage is unavailable.
        }
        pendingFunnelEvents.add(storageKey);

        const recommendation = details.recommendation;
        const payload = {
          eventId: newAnalyticsId('dkye'),
          eventType,
          visitorId,
          sessionId,
          stroller: details.stroller || state.stroller || '',
          configurationCount: state.configurations.length,
          actionType: details.actionType || '',
          recommendedSku: recommendation?.match?.variant?.sku || state.recommendedSku || '',
          storefrontCountry: config.storefrontCountry || ''
        };
        if (eventType === 'result_viewed') {
          payload.configurations = state.configurations.map((item) => ({ lower: item.lower, upper: item.upper }));
        }
        try {
          fetch(config.logEndpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then((response) => {
            if (!response.ok) throw new Error('Analytics endpoint rejected the event.');
            try { window.sessionStorage.setItem(storageKey, 'true'); } catch (_) {}
            pendingFunnelEvents.delete(storageKey);
          }).catch(() => {
            pendingFunnelEvents.delete(storageKey);
          });
        } catch (_) {
          pendingFunnelEvents.delete(storageKey);
          // Analytics must never interrupt the customer result.
        }
      };

      const renderResult = () => {
        if (!state.configurations.length) return;
        const recommendation = resolveRecommendation();
        state.recommendedSku = recommendation.match?.variant?.sku || '';
        const count = state.configurations.length;
        summary.textContent = `${labels.stroller[state.stroller]} · ${count} saved ${count === 1 ? 'configuration' : 'configurations'} · ${recommendation.parts.length} unique adapter ${recommendation.parts.length === 1 ? 'part' : 'parts'}`;
        renderPrimary(recommendation);
        live.textContent = recommendation.match
          ? `Your recommended kit is ${recommendation.match.product.title}.`
          : 'Your component combination has been calculated, but its Shopify bundle product still needs to be assigned.';
        showScreen('result');
        clearNextStep();
        scrollToMobileStep(resultHeading);
        trackFunnelEvent('result_viewed', { recommendation });
      };

      root.querySelectorAll('[data-dky-stroller]').forEach((button) => button.addEventListener('click', () => {
        const selected = button.dataset.dkyStroller;
        trackFunnelEvent('stroller_selected', { stroller: selected });
        if (selected === 'vista_pre2015') {
          showScreen('unsupported');
          return;
        }
        state.stroller = selected;
        selectedStroller.textContent = labels.stroller[selected];
        updateDraftControls();
        renderSavedConfigurations();
        showScreen('builder');
        highlightNextStep(upperPosition, 'start', false);
      }));

      root.querySelectorAll('[data-dky-lower]').forEach((button) => button.addEventListener('click', () => {
        state.draftLower = button.dataset.dkyLower;
        updateDraftControls();
        if (state.draftUpper) highlightNextStep(composerActions, 'center');
        else highlightNextStep(upperPosition);
      }));

      root.querySelectorAll('[data-dky-upper]').forEach((button) => button.addEventListener('click', () => {
        state.draftUpper = button.dataset.dkyUpper;
        updateDraftControls();
        if (state.draftLower) highlightNextStep(composerActions, 'center');
        else highlightNextStep(lowerPosition);
      }));

      saveButton.addEventListener('click', () => {
        if (!state.draftLower || !state.draftUpper) return;
        const duplicate = state.configurations.some((item) => (
          item.lower === state.draftLower && item.upper === state.draftUpper
        ));
        if (duplicate) {
          setComposerMessage('That configuration is already in your list.', true);
          live.textContent = 'That configuration is already saved.';
          highlightNextStep(composerActions, 'center');
          return;
        }

        state.configurations.push({ lower: state.draftLower, upper: state.draftUpper });
        trackFunnelEvent('configuration_saved');
        state.draftLower = '';
        state.draftUpper = '';
        updateDraftControls();
        renderSavedConfigurations();
        setComposerMessage('Configuration saved. Choose another pairing or find your kit.');
        live.textContent = `Configuration ${state.configurations.length} saved.`;
        highlightNextStep(savedPanel);
      });

      addAnotherButtons.forEach((button) => button.addEventListener('click', () => {
        state.draftLower = '';
        state.draftUpper = '';
        updateDraftControls();
        setComposerMessage('Start your next configuration by choosing an UPPER carrier.');
        live.textContent = 'Choose an upper carrier for your next configuration.';
        highlightNextStep(upperPosition, 'start', true, true);
      }));

      findButtons.forEach((button) => button.addEventListener('click', renderResult));

      root.addEventListener('click', (event) => {
        const action = event.target instanceof Element ? event.target.closest('[data-dky-product-action]') : null;
        if (!action || action.hasAttribute('disabled')) return;
        trackFunnelEvent('product_action', { actionType: action.dataset.dkyProductAction || '' });
      });

      root.querySelector('[data-dky-action="view-saved-configurations"]').addEventListener('click', (event) => {
        event.preventDefault();
        highlightNextStep(savedPanel, 'start', true, true);
      });

      root.querySelectorAll('[data-dky-action="change-stroller"]').forEach((button) => button.addEventListener('click', () => {
        showScreen('stroller');
      }));

      root.querySelectorAll('[data-dky-action="back"]').forEach((button) => button.addEventListener('click', () => {
        if (state.screen === 'result') {
          showScreen('builder');
          highlightNextStep(upperPosition, 'start', false);
        }
        else showScreen('stroller');
      }));

      root.querySelectorAll('[data-dky-action="restart"]').forEach((button) => button.addEventListener('click', () => {
        state.stroller = '';
        state.draftLower = '';
        state.draftUpper = '';
        state.configurations = [];
        state.recommendedSku = '';
        selectedStroller.textContent = '';
        productMount.innerHTML = '';
        clearNextStep();
        updateDraftControls();
        renderSavedConfigurations();
        showScreen('stroller');
      }));

      root.querySelectorAll('[data-dky-open-guide]').forEach((button) => button.addEventListener('click', () => guide.showModal()));
      root.querySelector('[data-dky-close-guide]').addEventListener('click', () => guide.close());
      guide.addEventListener('click', (event) => {
        if (event.target === guide) guide.close();
      });

      updateDraftControls();
      renderSavedConfigurations();
      trackFunnelEvent('page_view');
    };

    const initAll = () => document.querySelectorAll('[data-dky-root]').forEach(initFinder);
    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches?.('[data-dky-root]') ? event.target : event.target.querySelector?.('[data-dky-root]');
      initFinder(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
